import { useEffect } from 'react';
import { useIsMounted } from '@toss/react';
import { appendUTMParams } from '@/utils/analytics';
interface Props {
  webFormUrl: string;
  className?: string;
}
export function SalesMapEmbed({
  webFormUrl,
  className
}: Props) {
  const mounted = useIsMounted();
  useEffect(() => {
    if (mounted) {
      const script = document.createElement('script');
      script.id = 'loadFormScript';
      script.src = 'https://salesmap.kr/web-form-loader-v3.js';
      script.async = true;
      script.onload = () => {
        // @ts-expect-error -- SalesMap 외부 스크립트가 주입하는 전역 객체로 타입 정의 없음
        window.SmFormSettings.loadForm();
      };
      document.body.appendChild(script);
    }
  }, [mounted]);
  return <div id="salesmap-web-form"
  // 저장/현재 UTM 을 Salesmap 폼 URL 에 실어 attribution 전달.
  // 두 사용처 모두 <NoSSR> 로 감싸 client 전용 렌더라 hydration mismatch 없음.
  data-web-form={appendUTMParams(webFormUrl)} className={className} data-sentry-component="SalesMapEmbed" data-sentry-source-file="SalesMapEmbed.tsx"></div>;
}